import { Cart } from '@softapps/wws/pos-core';
import { equals, isNullOrEmpty } from '@softline/core';

export function isCartEqual(value: Cart | null, templateCart: Cart | null): boolean {
  return (
    (value?.items?.length ?? 0) === (templateCart?.items?.length ?? 0) &&
    (value?.cashbookEntries?.length ?? 0) ===
      (templateCart?.cashbookEntries?.length ?? 0) &&
    value?.documentType === templateCart?.documentType &&
    value?.currency === templateCart?.currency &&
    nullableEquals(
      `${value?.referenceDocument?.referenceDocumentId}_${value?.referenceDocument?.referenceDocumentType}`,
      `${templateCart?.referenceDocument?.referenceDocumentId}_${templateCart?.referenceDocument?.referenceDocumentType}`
    ) &&
    nullableEquals(value?.deliveryAddress, templateCart?.deliveryAddress) &&
    nullableEquals(value?.collector, templateCart?.collector) &&
    nullableEquals(value?.documentHeader, templateCart?.documentHeader) &&
    nullableEquals(value?.documentFooter, templateCart?.documentFooter) &&
    nullableEquals(value?.generalDiscount, templateCart?.generalDiscount) &&
    nullableEquals(value?.customerCard?.id, templateCart?.customerCard?.id) &&
    nullableEquals(value?.sellOff?.type, value?.sellOff?.type) &&
    equals(value?.account, templateCart?.account) &&
    equals(value?.address, templateCart?.address)
  );
}

function nullableEquals(
  value1: string | number | null | undefined,
  value2: string | number | null | undefined
): boolean {
  value1 = isNullOrEmpty(value1) ? null : value1;
  value2 = isNullOrEmpty(value2) ? null : value2;
  return value1 === value2;
}
